import { useQuery } from 'react-query';
import { useViewerStore } from '@store/viewerModule/base';
import getMetricsData from '@src/api/metricContainer';
import { buildRequestBody } from '../common/utils';
import { VM_LIVE_REFRESH_INTERVAL } from '@utils/constants';

function useFetchSummaryData(metricsList) {
  const [{ viewerId, interval }] = useViewerStore();
  const { startDate, endDate, days, isLive } = interval;
  const refetchInterval = isLive ? VM_LIVE_REFRESH_INTERVAL : false;
  const reqBody = buildRequestBody(viewerId, interval, metricsList);
  const body = JSON.parse(JSON.stringify(reqBody));
  const paramList = [viewerId, startDate, endDate, days];
  return useQuery(['getMetricsData', ...paramList], () => getMetricsData(body), {
    enabled: !!viewerId,
    retry: false,
    refetchOnWindowFocus: false,
    refetchInterval,
  });
}

export default useFetchSummaryData;
